import React, { useEffect, useRef, useState } from "react";
import "./Product_vdo_preview.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getAllCategories } from "../../../features/master/masterSlice";
import { getAllProducts } from "../../../features/products/productsSlice";
import Common_heading_holder from "../../common-components/common_heading_holder/Common_heading_holder";

import { variant_type } from "../../../utils/common";
import { encodeId } from "../../../utils/common";
import Product_Info_Card from "../../common-components/product_info_card/Product_Info_Card";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import No_data from "../../common-components/No_data/No_data";

function Product_vdo_preview() {
  const all_products = useSelector((state) => state.product.allProducts);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sectionRef = useRef(null);

  /* ---------------- REDUX DATA ---------------- */
  const productdata = useSelector((state) => state.product.allProducts);
  const products = productdata?.data || [];

  // ✅ FIXED CATEGORY SELECTOR
  const categories = useSelector((state) => state.master.categories) || [];

  /* ---------------- STATE ---------------- */
  const [activeTab, setActiveTab] = useState(null);

  /* ---------------- FETCH CATEGORIES ---------------- */
  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch]);

  /* ---------------- SET DEFAULT CATEGORY ---------------- */
  useEffect(() => {
    if (categories.length > 0 && !activeTab) {
      const firstCategory = categories[0];
      setActiveTab(firstCategory.id);

      dispatch(getAllProducts({ category_id: firstCategory.id }));
    }
  }, [categories, activeTab, dispatch]);

  /* ---------------- HANDLE TAB CLICK ---------------- */
  const handleTabClick = (catId) => {
    setActiveTab(catId);
    dispatch(getAllProducts({ category_id: catId }));
  };

  /* ---------------- HANDLE SHOP NOW CLICK ---------------- */
  const handleShopNow = (productId, categoryId) => {
    // Navigate to categories page with category_id
    // navigate(`/categories?category_id=${categoryId}`);

    navigate(`/product-details/${encodeId(productId)}`);
  };

  const bestSellerProducts = all_products?.data?.filter(
  (p) => p.best_seller_status === true
) || [];

  return (
    <div className="Product_vdo_preview" ref={sectionRef}>
      <div className="container-fluid">
        {/* HEADER */}
        <div className="bestseller_header">
          <Common_heading_holder
            heading_text={
              <>
                <span className="black-text">Our </span>
                <br />
                <span className="blue-text">Bestsellers</span>
              </>
            }
          />

          {/* ✅ DYNAMIC CATEGORIES */}
          <div className="tabs_holder">
            {categories.length > 0 ? (
              categories.map((cat) => (
                <button
                  key={cat.id}
                  className={`tab_btn ${activeTab === cat.id ? "active" : ""}`}
                  onClick={() => handleTabClick(cat.id)}
                >
                  {cat.name}
                </button>
              ))
            ) : (
              <span className="text-white px-3">Loading...</span>
            )}
          </div>
        </div>

        {/* LAYOUT */}
        <Swiper
          className="product_swiper"
          modules={[Navigation]}
          navigation
          spaceBetween={10}
          breakpoints={{
            0: { slidesPerView: 2 },
            576: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            992: { slidesPerView: 4 },
            1200: { slidesPerView: 5 },
          }}
        >
          {/* {all_products?.data?.map((product, index) => { */}
          {bestSellerProducts.map((product, index) => {
            let metal;
            let size;
            let triple;

            if (
              Number(product?.variant_type_id) === Number(variant_type.Single)
            ) {
              metal = product?.Product_Variants?.[0];
            } else if (
              Number(product?.variant_type_id) === Number(variant_type.Double)
            ) {
              metal = product?.Product_Variants?.[0];
              size = metal?.Double_Variants?.[0];
            } else if (
              Number(product?.variant_type_id) === Number(variant_type.Triple)
            ) {
              metal = product?.Product_Variants?.[0];
              size = metal?.Double_Variants?.[0];
              triple = size?.Triple_Variants?.[0];
            }

            const activeVariant = triple || size || metal;

            return (
              <SwiperSlide key={product?.id || index}>
                  <Product_Info_Card
                    product={product}
                    id={product?.id}
                    imgSrc={process.env.REACT_APP_IMG_URL + product?.image}
                    vdoSrc={process.env.REACT_APP_IMG_URL + product?.video}
                    productName={product?.name}
                    mrp={activeVariant?.mrp || 0}
                    priceText={activeVariant?.price || 0}
                    kgText={activeVariant?.name}
                    savingPrice={
                      parseFloat(activeVariant?.mrp || 2) -
                      parseFloat(activeVariant?.price || 2)
                    }
                  />
              </SwiperSlide>
            );
          })}

          
        </Swiper>

        {/* NO DATA */}
        {bestSellerProducts.length === 0 && (
          <div className="text-center mt-4">
            <No_data/>
            <h5>No Products Available</h5>
          </div>
        )}
      </div>
    </div>
  );
}

export default Product_vdo_preview;
